/** An enum that represents filter scope */
export enum FilterScope {
  /** The filtered content must contain the filter text */
  Contains,

  /** The filtered content must start with the filter text */
  StartsWith,

  /** The filtered content must end with the filte text */
  EndsWith
}
